import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: [],
	columnFields: ['id', 'metadataType', 'metadata', 'createdAt', 'createdBy'] as const,
	standardFilterFields: ['metadataType'] as const,
	dateFilterFields: [],
	stageStatusFilterFields: [],
	booleanFilterFields: [] as const,
});
